
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as WarningIconComponent } from "./warning-icon.svg";

export const WarningIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <WarningIconComponent {...props} />;
};
